import type { ReferencePreview } from './transformToolsData';

/**
 * Filter a hierarchy of reference previews by referenceFilter (multi-select),
 * healthFilter, and search text.
 *
 * Pure function — no side effects. Intended for use in useMemo inside ToolListPage
 * and for direct unit testing.
 */
export function filterHierarchy(
  hierarchy: ReferencePreview[],
  referenceFilter: string[],
  healthFilter: string | null,
  search: string
): ReferencePreview[] {
  return hierarchy
    .map((reference) => {
      let filteredTools = reference.tools;

      // ToolState filter: only show tools with matching state
      if (healthFilter) {
        filteredTools = filteredTools.filter((tool) => tool.toolState === healthFilter);
      }

      // Search filter: filter tools by ID
      if (search) {
        const searchLower = search.toLowerCase();
        const matchesReference = reference.reference.toLowerCase().includes(searchLower);
        if (!matchesReference) {
          filteredTools = filteredTools.filter((tool) =>
            tool.id.toLowerCase().includes(searchLower)
          );
        }
      }

      return {
        ...reference,
        tools: filteredTools,
      };
    })
    .filter((reference) => {
      // Reference filter (multi-select): check if the reference is included in the selected set
      if (referenceFilter.length > 0 && !referenceFilter.includes(reference.reference)) {
        return false;
      }

      // Only keep references that have at least one tool after filtering
      return reference.tools.length > 0;
    });
}
